module.exports = __webpack_public_path__ + "static/media/whitelogo.2ac0a376.png";